<div class="loader">
  <img src="assets/images/loader.svg" alt="loading">
</div>
